import { filter } from 'rxjs/operators';
import { LoaderService } from './../../services/loader.service';
import { AfterViewInit, Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { zip } from 'rxjs';
import { GalleryImageModel } from 'src/app/models/gallery-image-model';
import { KeyNameModel } from 'src/app/models/key-value-model';
import { Business } from 'src/app/models/register-business';
import { BusinessService } from 'src/app/services/business.service';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
})
export class GalleryComponent implements AfterViewInit {
  model!: NgbDateStruct;
  photoCategories: KeyNameModel[] = [];

  constructor(
    private ngbDateParserFormatter: NgbDateParserFormatter,
    public businessService: BusinessService,
    public userService: UserService,
    public toastService: ToastrService,
    public loaderService: LoaderService,
    public authService: AuthService,
    private route: ActivatedRoute) { }
  businessDetails: Business = new Business();
  bussinessImages: any;
  galleryImages: GalleryImageModel[] = [];
  allowEditDetails: boolean = false;
  branchId: number;
  active = 1;

  ngAfterViewInit() {
    const branchId = localStorage.getItem('branchId');
    if (branchId === this.businessDetails.branchId.toString()) {
      this.allowEditDetails = true;
    }
  }

  getFormattedDate(date: NgbDateStruct): string {
    if (!date) return '';
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = days[jsDate.getDay()];
    const month = months[jsDate.getMonth()];
    const year = jsDate.getFullYear();

    // Formatted date string
    return `${day}, ${month} ${jsDate.getDate()}`;
  }

  peopleSelect!: number;
  timeSelect!: number;
  peoples = [
    { id: 1, name: '2 people' },
    { id: 2, name: '4 people' },
    { id: 3, name: '8 people' },
  ];

  times = [
    { id: 1, name: '8:00 pm' },
    { id: 2, name: '9:00 pm' },
    { id: 3, name: '10:00 pm' },
  ];

  //for static purpose only end

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.branchId = Number.parseInt(params["id"]);
      if (this.branchId) {
        this.loaderService.setLoading(true);
        zip(
          this.businessService.getBusinessById(this.branchId),
          this.userService.getAll(`api/getEnumList/MembershipBranchImageType`),
        ).subscribe(([businessDetials, photoCategories
        ]: any[]) => {
          this.businessDetails = businessDetials;

          this.photoCategories = photoCategories.map(item => ({
            id: item.value,
            name: item.enumDescription,
          }));

          this.photoCategories.forEach(category => {
            this.galleryImages.push({
              id: category.id,
              category: category.name,
              images: this.businessDetails.membershipBusinessImagesList.filter(x => x.imageType == category.id).map(item => ({
                src: item.imagePath
              }))
            });
          });
          this.loaderService.setLoading(false);
        });
      }
    });
    window.scroll(0, 1);
  }
}
